<script lang="ts">
import {computed, defineComponent, PropType} from '@vue/composition-api'
import {TranslateResult} from 'vue-i18n'

import {themes} from './theme'
import {Variant} from './types'

const DOUBLE_CHECK = 'fa-check-double'

export default defineComponent({
  name: 'MChip',
  inheritAttrs: false,
  props: {
    icon: {
      type: String,
      required: false,
    },
    text: {
      type: String as PropType<string | TranslateResult>,
      required: true,
    },
    tooltip: {
      type: String as PropType<string | TranslateResult>,
      required: false,
    },
    trailingIcon: {
      type: String,
      required: false,
    },
    variant: {
      type: String as PropType<Variant>,
      required: false,
    },
  },
  setup(props: any) {
    const theme = computed(() => {
      return themes[props.variant as Variant]
    })

    const isDoubleCheck = computed(() => props.trailingIcon === DOUBLE_CHECK)

    return {theme, isDoubleCheck}
  },
})
</script>

<template>
  <v-tooltip v-if="tooltip" bottom color="#000">
    <template v-slot:activator="{on}">
      <v-chip :color="theme.colorBackground" :text-color="theme.colorText" v-bind="$attrs" v-on="on">
        <v-icon :color="theme.colorIcon" x-small>fa-regular {{ icon || 'fa-check' }}</v-icon>
        <span class="chip-text">{{ text }}</span>
        <span v-if="isDoubleCheck" class="chip-trailing chip-trailing--double">
          <img class="chip-check" src="/images/offer/check.svg" alt="" />
          <img class="chip-check chip-check--second" src="/images/offer/check.svg" alt="" />
        </span>
        <v-icon v-else-if="trailingIcon" :color="theme.colorIcon" x-small class="chip-trailing">
          fa-regular {{ trailingIcon }}
        </v-icon>
      </v-chip>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>

  <v-chip v-else :color="theme.colorBackground" :text-color="theme.colorText" v-bind="$attrs">
    <v-icon :color="theme.colorIcon" x-small>fa-regular {{ icon || 'fa-check' }}</v-icon>
    <span class="chip-text">{{ text }}</span>
    <span v-if="isDoubleCheck" class="chip-trailing chip-trailing--double">
      <img class="chip-check" src="/images/offer/check.svg" alt="" />
      <img class="chip-check chip-check--second" src="/images/offer/check.svg" alt="" />
    </span>
    <v-icon v-else-if="trailingIcon" :color="theme.colorIcon" x-small class="chip-trailing">
      fa-regular {{ trailingIcon }}
    </v-icon>
  </v-chip>
</template>

<style scoped>
.chip-text {
  font-family: 'ProximaNovaSemibold', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.2;
  margin-left: 0.45em;
}

.chip-trailing {
  margin-left: 0.45em;
}

.chip-trailing--double {
  display: inline-flex;
  align-items: center;
}

.chip-check {
  display: block;
  position: relative;
}

.chip-check:first-child {
  z-index: 1;
}

.chip-check--second {
  margin-left: -7px;
}
</style>
